<template>
  <div>
    <div class="details-banner top">
      <div class="details-intro">
        <el-row :gutter="40">
          <el-col :span="24">
            <div class="title">{{ detail.solutionTitle }}</div>
          </el-col>
          <el-col :xs="24" :md="18">
            <div class="subtitle">{{ detail.schemeIntroduction }}</div>
          </el-col>
          <!-- <el-col :xs="24" :md="8" :lg="6">
            <div class="subtitle">{{ detail.productionCompany }}<br/>联系方式:{{ detail.contactEmail }}</div>
          </el-col> -->
          <el-col :xs="24" :lg="12">
            <!-- <el-row :gutter="20">
              <el-col  style="margin-bottom: 10px">
                <div class="btn" @click="() => { open = true; title = detail.solutionTitle }">方案咨询</div>
              </el-col>
              <el-col>

                <ul class="inbutton" :class="mousein ? 'inmouse' : ''" @mouseover="inMouse" @mouseout="outMouse">
                  <li class="btn1">进入系统 <i style="margin-left: 8px;" class="el-icon-arrow-down"></i></li>
                  <li>收运演示系统一</li>
                  <li>收运演示系统二</li>
                  <li>收运演示系统三</li>
                </ul>
              </el-col>
            </el-row> -->
            <el-row :gutter="20">
              <el-col :xs="12" :lg="8" :xl="6" style="margin-top: 40px">
                <div
                  class="btn"
                  @click="
                    () => {
                      open = true;
                      title = detail.solutionTitle;
                    }
                  "
                >
                  方案咨询
                </div>
              </el-col>
              <el-col :xs="12" :lg="8" :xl="6">
                <!-- <div class="btn1" @click="toSystem(detail.systemLink)">进入系统</div> -->
                <!-- <div class="btn1">进入系统 <i style="margin-left: 8px;" class="el-icon-arrow-down"></i></div> -->
                <!-- <ul
                  class="inbutton"
                  :class="mousein ? 'inmouse' : ''"
                  @mouseover="inMouse"
                  @mouseout="outMouse"
                  v-if="
                    detail.linkStatus == '1' &&
                    detail.systemLinkData !== null &&
                    detail.systemLinkData.length > 1
                  "
                >
                  <li class="btn1">
                    立即使用
                    <i style="margin-left: 8px" class="el-icon-arrow-down"></i>
                  </li>
                  <li
                    v-for="(item, index) in detail.systemLinkData"
                    :key="index"
                    @click="toSystem(item.url)"
                  >
                    {{ item.name }}
                  </li>
                </ul> -->
                <div
                  v-if="
                    detail.linkStatus == '1' &&
                    detail.systemLinkData !== null &&
                    detail.systemLink !== '[]' &&
                    detail.systemLink !== 'null' &&
                    detail.systemLinkData
                  "
                  class="btn1"
                  @click="toSystem(detail.systemLinkData[0].url)"
                >
                  立即使用
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!-- <img :src="detail.backgroundImage" style="width: 100%; height: 100%"/> -->
    </div>
    <div class="details-container">
      <!-- <div class="details-head w-full flex align-middle justify-center gap-2">
        <div
          v-for="(item, index) in detail.infoList"
          :class="{ 'text-activate': active == index }"
          v-if="item.moduleStatus === '1'"
          :key="index"
          @click="handlePositionClock(item.moduleTitle)"
        >
          {{ item.moduleName }}
        </div>
      </div> -->

      <div class="contant">
        <div class="list" :class="{'fixed': isNavFixed}">
          <div class="tabItem" style="text-align: center; margin-bottom: 40p;background-color: #fff;">
            <div
              v-for="(item, index) in titlelists"
              :key="index"
              style="
                font-weight: 500;
                padding: 0 20px;
                cursor: pointer;
                color: #000;
                display: inline-block;
                font-size: 16px;
              "
            >
              <div
                :class="{ active: typeActive == index }"
                style="padding: 15px 0px"
                @click="changeTypeActive(index, item)"
              >
                {{ item }}
              </div>
              <!-- <div
                v-show="typeActive == index"
                style="border-bottom: 2px solid #d7000f"
              >
                <div style="width: 100%"></div>
              </div> -->
            </div>
          </div>
        </div>
        <div
          class="item"
          v-for="(item, index) in detail.infoList"
          :key="index"
          v-if="item.moduleStatus === '1'"
          :id="`iddtail${item.moduleTitle}`"
        >
          <div
            class="contant-title"
            v-if="detail.infoList && item.moduleName !== '自定义模块'"
          >
            <span></span>
            <span>{{ item.moduleTitle }}</span>
          </div>
          <el-row :gutter="20" class="xxxxxx">
            <!-- 痛点模块 -->
            <div v-if="item.moduleName === '痛点模块'">
              <el-col
                v-for="(v, i) in item.contentList"
                :key="v.id"
                :xs="24"
                :sm="8"
                :lg="6"
              >
                <div class="box">
                  <img
                    style="width: 68px; height: 68px"
                    :src="`/static/img/jjfa/${i + 1}.png`"
                  />
                  <div class="label hidden-1">{{ v.subtitle }}</div>
                  <div class="desc hidden-3">{{ v.introduction }}</div>
                </div>
              </el-col>
            </div>

            <!-- 案例模块 -->
            <div v-if="item.moduleName === '案例模块'">
              <el-col class="dxal-box" :xs="24" :sm="8" :lg="6">
                <div
                  v-for="item2 in caseList"
                  :key="item2.id"
                  class="box"
                  @click="toPage(item2)"
                >
                  <div style="width: 100%; height: 100%">
                    <img :src="item2.caseCover" alt="" />
                  </div>
                  <div class="dxal-title">{{ item2.caseTitle }}</div>
                </div>
                <!-- <div
                  v-if="detail.infoList[3].contentList[0]"
                  class="box"
                  @click="toPage(detail.infoList[3].contentList[0])"
                >
                  <div style="width: 100%; height: 100%">
                    <img :src="caseone.schemeCover" alt="" />
                  </div>
                  <div class="dxal-title">{{ caseone.solutionTitle }}</div>
                </div>
                <div
                  v-if="detail.infoList[3].contentList[1]"
                  class="box"
                  @click="toPage(detail.infoList[3].contentList[1])"
                >
                  <div style="width: 100%; height: 100%">
                    <img :src="casetwo.schemeCover" alt="" />
                  </div>
                  <div class="dxal-title">{{ casetwo.solutionTitle }}</div>
                </div>
                <div
                  v-if="detail.infoList[3].contentList[2]"
                  class="box"
                  @click="toPage(detail.infoList[3].contentList[2])"
                >
                  <div style="width: 100%; height: 100%">
                    <img :src="casethree.schemeCover" alt="" />
                  </div>
                  <div class="dxal-title">{{ casethree.solutionTitle }}</div>
                </div> -->
              </el-col>
            </div>
            <!-- 功能模块 -->
            <div v-if="item.moduleName === '功能模块'">
              <el-col
                v-for="(v, i) in item.contentList"
                :key="v.id"
                :xs="24"
                :md="12"
                style="margin-bottom: 20px"
              >
                <div style="margin-top: 10px" class="evenflow_scale">
                  <el-row :gutter="20">
                    <el-col :xs="8" :md="8" :lg="6" :xl="5">
                      <img
                        :src="v.picture"
                        style="width: 80px; min-height: 66px"
                      />
                    </el-col>
                    <el-col :xs="16" :md="14" :lg="16" :xl="17">
                      <label style="font-size: 18px; color: #131415">{{
                        v.subtitle
                      }}</label>
                      <div class="module-detail">{{ v.introduction }}</div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </div>
            <!-- 自定义模块 -->
            <div
              v-if="item.moduleName === '自定义模块' && item.contentList.length"
            >
              <el-col
                :span="24"
                v-for="(v, i) in item.contentList"
                :key="v.id"
                v-if="v.type"
                :id="`iddtail${v.subtitle}`"
              >
                <div
                  class="contant-title"
                  v-if="v.type === 'subtitle' && v.subtitle"
                >
                  <span></span>
                  <span>{{ v.subtitle }}</span>
                </div>
                <div
                  style="
                    font-size: 18px;
                    line-height: 28px;
                    padding: 16px 0;
                    color: #000;
                    font-weight: 500;
                  "
                  v-if="v.type === 'introduction' && v.introduction"
                >
                  {{ v.introduction }}
                </div>

                <div
                  v-if="v.type === 'picture' && v.picture"
                  style="width: 100%"
                >
                  <img :src="v.picture" style="width: 100%; margin: 25px 0" />
                </div>
                <div
                  v-if="v.type === 'video' && v.video"
                  style="width: 1000px; height: 562px; margin: 0 auto 50px auto"
                >
                  <video style="width: 100%" :src="v.video" muted loop controls>
                    <source type="video/mp4" :src="v.video" />
                  </video>
                </div>
              </el-col>
            </div>
          </el-row>
        </div>
      </div>
    </div>

    <consult
      v-if="open"
      :dialogVisible="open"
      @cancel="cancle"
      :productName="title"
      :isProduc="true"
      productId="0"
    >
    </consult>
    <div v-if="showButton" class="to-top" @click="totop()">
      <img src="../../assets/images/totop.png" alt="" />
    </div>
  </div>
</template>

<script>
import { detailSolution, detail1, detailCase } from "@/api";

export default {
  name: "SolutionDetails",
  data() {
    return {
       // 返回顶部按钮
       showButton: false,
      isNavFixed: false,  
      open: false,
      title: undefined,
      mousein: false,
      detail: {},
      activate: 0,
      lists: [],
      typeActive: 0,
      titlelists: [],
      id: [],
      caseone: "",
      casetwo: "",
      casethree: "",
      caseList: [],
    };
  },
  created() {
    this.getList();
  }, 
   mounted() {  
    window.addEventListener('scroll',  this.handleScroll);  
  },  
  beforeDestroy() {  
    window.removeEventListener('scroll',  this.handleScroll);  
  },  
  methods: {
    totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
    handleScroll() {  
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;  
      const topHeight = this.$el.querySelector('.top').offsetHeight;  
      this.isNavFixed = scrollTop >= topHeight;  
      this.showButton  = window.scrollY  > 200; 
    },  
    changeTypeActive(index, item) {
      this.typeActive = index;
      this.$el.querySelector(`#iddtail${item}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "center",
      });
    },
    async getList() {
      const res = await detailSolution({ id: this.$route.query.id });
      this.detail = res.data;

      this.lists = res.data.infoList[2].contentList;
      // this.lists.map((item) => {
      //   if(item.subtitle !== null){
      //     this.titlelists.unshift(item.subtitle)
      //   }
      //   return this.titlelists;
      // })

      res.data.infoList.forEach((t, i) => {
        if (i == 2) {
          this.lists.map((item) => {
            if (item.subtitle) {
              this.titlelists.push(item.subtitle);
            }
            // return this.titlelists;
          });
        } else {
          if (t.moduleTitle && t.moduleStatus === "1") {
            this.titlelists.push(t.moduleTitle);
          }
        }
      });

      for (let i = 0; i < res.data.infoList[3].contentList.length; i++) {
        this.id.push(res.data.infoList[3].contentList[i].linkInfo);
        detailCase({ id: res.data.infoList[3].contentList[i].linkInfo }).then(
          (res) => {
            this.caseList.push(res.data);
          }
        );
      }

      // const res1 = await detail1({ id: this.id[0] });
      // this.caseone = res1.data;
      // const res2 = await detail1({ id: this.id[1] });
      // this.casetwo = res2.data;
      // const res3 = await detail1({ id: this.id[2] });
      // this.casethree = res3.data;
    },
    toPage(item) {
      this.$router.push({ path: "/solition_lower", query: { id: item.id } });
    },
    cancle(data) {
      this.open = data;
    },
    toSystem(url) {
      let jumpUrl = url;
      // const result = jumpUrl.match("login");
      const result = false;
      if (!result) {
        if (url !== "http://cwzx.eiiplat.com/taxPlan/index") {
          url = `${url}#/login`;
          window.open(
            url +
              (localStorage.usertoken ? `?token=${localStorage.usertoken}` : "")
          );
        } else {
          window.open(
            url +
              (localStorage.usertoken
                ? `?token=${localStorage.usertoken}&userId=${localStorage.userId}`
                : "")
          );
        }
      }
    },
    inMouse() {
      // 鼠标移入
      this.mousein = true;
    },
    outMouse() {
      this.mousein = false;
    },
  },
  watch: {
    "$route.query.id"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
.fixed {  
  z-index: 999999;
  position: fixed;
    top: 60px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
}  
.dxal-box {
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  /* margin-right: 30px; */
  width: 100%;
}
.dxal-title {
  height: 47px;
  position: relative;
  bottom: 47px;
  text-align: center;
  color: #fff;
  background-color: #0006;
  width: 332px;
  line-height: 47px;
  font-size: 13px;
}
.active {
  color: red !important;
}
.inbutton {
  list-style: none;
  height: 37px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  transition: all 0.3s;

  &.inmouse {
    height: auto;

    li {
      transition: all 0.5s;

      &:not(:first-child) {
        opacity: 1;
      }
    }
  }

  li {
    transition: all 0.5s;

    &:not(:first-child) {
      width: 120px;
      height: 30px;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, 0.6);
      opacity: 0;
      // display: none;
    }
  }
}

.details-banner {
  width: 100%;
  height: 450px;
  background: url("~@/assets/images/Rectangle.png") lightgray 0px 0px / 100%
    100% no-repeat;
  position: relative;

  .details-intro {
    width: 1280px;
    margin-left: -640px;
    position: absolute;
    top: 30%;
    left: 50%;
    color: #333;

    .title {
      font-size: 40px;
      font-weight: 500;
      margin-bottom: 16px;
    }

    .subtitle {
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      max-height: 112px;
      overflow: hidden;
      text-overflow: ellipsis; //超出文本设置为...
      display: -webkit-box; //将div1转换为盒子模型
      -webkit-line-clamp: 4; //设置div1的文本为2行
      -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
    }

    .btn {
      width: 136px;
      height: 44px;
      font-size: 14px;
      line-height: 44px;
      color: #fff;
      background: #e50009;
      text-align: center;
      cursor: pointer;
      border: 1px solid #e50009;
    }

    .btn1 {
      border: 1px solid #fff;
      background: #fff;
      box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1),
        0px 4px 20px 1px rgba(255, 255, 255, 0.5) inset;
        width: 136px;
      height: 44px;
      font-size: 14px;
      line-height: 44px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.details-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 360px;
  margin-bottom: 80px;

  .details-head {
    width: 1920px;
    height: 60px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(5px);

    > div {
      display: flex;
      width: 170px;
      padding: 0px 20px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      align-self: stretch;
    }
  }

  .contant {
    width: 1280px;

    .item {
      /* margin-bottom: 50px; */
      .module-detail {
        font-size: 14px;
        color: #131415;
        opacity: 0.6;
        margin: 20px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 38px;
      }
    }

    .contant-title {
      height: 45px;
      font-weight: 700;
      color: #000000;
      margin-top: 40px;
      margin-bottom: 40px;
      text-align: center;

      :first-child {
        width: 3px;
        height: 20px;
        background: #e50009;
        margin-right: 5px;
      }

      span {
        font-size: 32px;
      }
    }

    .card {
      box-shadow: 0rem 0.04rem 0.3rem 0rem rgba(204, 204, 204, 0.7);
      margin-bottom: 40px;
    }

    .box {
      text-align: left;
      cursor: pointer;
      margin-right: 30px;
      height: 200px;
      width: 332px;
      transition: all 0.5s;
      img {
        width: 100%;
        height: 100%;
      }

      .label {
        font-size: 40px;
        font-weight: 400;
        line-height: 60px;
        color: #131415;
      }

      .desc {
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
        color: #333333;
      }
    }

    .box:hover {
      // box-shadow: 0px 4px 20px 0px rgba(204, 204, 204, 0.6);

      // .label {
      //   color: #e50009;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SolutionDetails/index.vue